import React from "react";
import { Link } from "react-router-dom";

export default function ParticipantHome() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Participant Dashboard</h1>
      <p className="text-gray-600">Welcome! You can manage your attendance here.</p>
      <div className="grid gap-3 md:grid-cols-2">
        <Link to="/participant" className="p-4 border rounded-xl hover:bg-gray-50 block">
          Attendance QR & Code
        </Link>
      </div>
    </div>
  );
}
